<template>
  <transition name="el-fade-in-linear">
    <div class="join">
      <div class="main">
        <div class="firstItem1Join">
          <img class="firstPic" src="../../static/images/joinPic1.png" />
        </div>
        <div class="firstItemJoin">
          <div class="firstTextJoin">加入我们</div>
          <div class="firstText1Join">期待与你一同加入</div>
          <div class="firstText1Join">北斗智能</div>
          <div class="line"></div>
          <div class="lineJoinNews"></div>
        </div>
        <img class="jointext1" src="../../static/images/jointext1.png" />
        <br />
        <div class="secondTitle">人才招聘</div>
             <div class="secondLevel">
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 1}}">
            <div class="secondTextJoin">产品经理（员工&实习）</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 2}}">
            <div class="secondTextJoin">项目经理（员工&实习）</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 3}}">
            <div class="secondTextJoin">解决方案经理</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 4}}">
            <div class="secondTextJoin">大数据工程师</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 5}}">
            <div class="secondTextJoin">数据分析工程师</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 6}}">
            <div class="secondTextJoin">高级销售经理</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
          <router-link class="card" :to="{path:'/JoinDetail',query: {index: 7}}">
            <div class="secondTextJoin">图像算法实习生</div>
            <div class="secondText1Join">工作地点：深圳市</div>
          </router-link>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {
    goDetail: function () {
      this.$router.push({
        path: "JoinDetail",
      });
    },
  },
};
</script>
<style scoped>
@import "./Join.css";
</style>



// WEBPACK FOOTER //
// src/views/Join.vue